/**
 * The storage key for the blog article.
 * Old key: free-avia:blog-article - for old blog articles
 * New key: free-avia:freedom-blog-article
 * @type {string}
 */
export const BLOG_ARTICLE_STORAGE_KEY = 'free-avia:freedom-blog-article';
